export default __webpack_public_path__ + "static/media/Chinmay Nagarkar.d63bd7ec.jpg";